// This code is for the popup/modal for Gift hampers additional notes.
//  It popups whenever customer choose a product that are either Hampers or Leave it to us 

document.addEventListener("DOMContentLoaded", function () {


  const modal = document.getElementById("giftHamperModal");
  const cancelBtn = document.getElementById("cancelGift");
  const form = document.getElementById("giftHamperForm");
  const hiddenProductId = document.getElementById("giftProductId");
  let currentForm = null;


// Intercept add-to-cart clicks
document.addEventListener("click", function (e) {
  const btn = e.target.closest("button.add-to-cart[data-js-product-add-to-cart]");
  if (btn && !btn.disabled && !btn.classList.contains("disabled")) {
    
    // Check product type from container
    const productContainer = btn.closest('[data-product-type]');
    const productType = productContainer ? productContainer.dataset.productType : null;

    const isHamperProduct = productType === "Hampers";
    const isLeaveItToUsProduct = productType === "'Leave it to Us'";

    // Skip normal flow unless it's Hampers or Leave it to Us
    if (!isHamperProduct && !isLeaveItToUsProduct) {
      return; // Let normal add-to-cart behavior happen
    }

    e.preventDefault();

    currentForm = btn.closest("form");

    // Grab the variant id from the existing product form
    const variantInput = currentForm.querySelector('input[name="id"]');
    if (variantInput) {
      hiddenProductId.value = variantInput.value;
    }

    modal.style.display = "flex"; // show modal
  }
});


  // Cancel button closes modal
  cancelBtn.addEventListener("click", function () {
    modal.style.display = "none";
  });

  // Handle modal form submit
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        modal.style.display = "none";
        
        // First, update the cart drawer content
        return fetch('/cart');
      })
      .then(response => response.text())
      .then(html => {
        // Parse the response and update the drawer
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = newDoc.getElementById('site-cart-sidebar');
        
        if (newCartDrawer) {
          // Replace the entire drawer with updated content
          const currentCartDrawer = document.getElementById('site-cart-sidebar');
          currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
          
          // Now trigger the theme's function to show it
          const productForm = document.querySelector('[data-js-product-form]');
          if (productForm) {
            productForm.dispatchEvent(new CustomEvent('add-to-cart'));
          }
        }
      })
      .catch(err => {
        console.error("Error adding to cart ❌", err);
      });
  });
});
